import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import {
  Employee,
  EmployeeFormInputProps,
} from 'src/components/EmployeeForm/EmployeeForm.utils';
import { Input } from 'src/components/Input/Input';

export function FirstNameInput({
  name,
  id,
}: EmployeeFormInputProps): JSX.Element {
  const { errors, register } = useFormContext<Employee>();

  return (
    <Input
      maxLength={60}
      label="First name"
      name={name}
      id={id}
      ref={register({
        required: 'First name is required',
      })}
      error={errors.first_name}
    />
  );
}
